/* global __APP_VERSION__ */
// __APP_VERSION__ wordt bij de build door Vite ingevuld (zie frontend/vite.config.js)
// met het nummer uit version.txt in de repo-root.
export const APP_VERSION = typeof __APP_VERSION__ === 'undefined' ? 'dev' : __APP_VERSION__;

export default APP_VERSION;
